package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.Toast
import top.wcpe.allincore.ui.runtime.ir.eval.ValueCoercion
import kotlin.jvm.JvmStatic

/**
 * Toast 元素属性贡献者：登记 message / kind / duration / position 四项静态属性。
 */
internal object ToastPropContributor {

    @JvmStatic
    fun contribute(m: MutableMap<String, PropBinding>) {
        m.put(
            "message",
            PropBinding.writeOnly { el, v ->
                if (el is Toast) {
                    el.message(v?.toString() ?: "")
                }
            },
        )
        m.put(
            "kind",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Toast) {
                    el.kind(v.toString())
                }
            },
        )
        m.put(
            "duration",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Toast) {
                    el.duration(ValueCoercion.toDouble(v).toLong())
                }
            },
        )
        m.put(
            "position",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Toast) {
                    el.position(v.toString())
                }
            },
        )

        // 逐实例样式覆盖
        mergeToast(m, "backgroundColor") { t, v -> t.backgroundColor(v?.let { ValueCoercion.toIntColor(it) }) }
        mergeToast(m, "textColor") { t, v -> t.textColor(v?.let { ValueCoercion.toIntColor(it) }) }
    }

    private fun mergeToast(m: MutableMap<String, PropBinding>, key: String, applier: (Toast, Any?) -> Unit) {
        val existing = m[key]
        if (existing == null) {
            m.put(
                key,
                PropBinding.writeOnly { el, v ->
                    if (el is Toast) applier(el, v)
                },
            )
            return
        }
        val prev = existing.applier
        val combined: PropApplier = { el, v ->
            if (el is Toast) {
                applier(el, v)
            } else {
                prev.apply(el, v)
            }
        }
        m.put(key, PropBinding.of(combined, existing.reader))
    }
}
